import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useEffect } from 'react';
import AdminTable from '../../components/admin/AdminTable';
import { useGetAllLogbooksApi } from '../../api/LogbookApi';
import SimpleSnackbar from '../../components/ui/SimpleSnackbar';
import { useState } from 'react';
import { LinearProgress } from '@mui/material';
import { isUserCustomerAdmin } from '../../components/auth/authorization';

export default function Admin() {
    const loginUser = useOutletContext().loginUser;
    let navigate = useNavigate();
    const [message, setMessage] = useState('');
    const setBadgePendingLogbooks = useOutletContext().setBadgePendingLogbooks;
    const [logbookFilter, setLogbookFilter] = useState([{ name: 'Status', value: 'active', index: 1 }]);
    let logbookList = useGetAllLogbooksApi(setMessage, logbookFilter);

    useEffect(() => {
        if (!isUserCustomerAdmin(loginUser.adminRoles)) {
            navigate('/');
        }
    }, [loginUser.adminRoles, navigate]);

    useEffect(() => {
        setBadgePendingLogbooks(logbookList?.filter((logbook) => logbook.status === 'pending')?.length);
    }, [logbookList, setBadgePendingLogbooks]);

    if (!logbookList) {
        return (
            <>
                <LinearProgress />
                {message && <SimpleSnackbar message={message} setMessage={setMessage} />}
            </>
        );
    }

    if (!isUserCustomerAdmin(loginUser.adminRoles)) {
        return <>{message && <SimpleSnackbar message={message} setMessage={setMessage} />}</>;
    } else {
        return (
            <>
                <AdminTable providedlogbookList={logbookList} logbookFilter={logbookFilter} setLogbookFilter={setLogbookFilter} />
                {message && <SimpleSnackbar message={message} setMessage={setMessage} />}
            </>
        );
    }
}
